import React from 'react'
import GridIcons from '@/icons/GridIcons'
import BurgerMenuIcons from '@/icons/BurgerMenuIcons'

export type ViewType = 'grid' | 'list'

interface ViewTypeSwitchProps {
    value: ViewType
    onChange: (next: ViewType) => void
    className?: string
}

const ViewTypeSwitch: React.FC<ViewTypeSwitchProps> = ({
    value,
    onChange,
    className,
}) => {
    const isGrid = value === 'grid'
    return (
        <div
            className={`inline-flex rounded-md border border-gray-200 ${className || ''}`}
        >
            <button
                type="button"
                className={`px-3 py-1.5 text-sm rounded-l-md ${
                    isGrid
                        ? 'bg-[#E6F0FF] text-[#31398B] font-semibold'
                        : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
                onClick={() => onChange('grid')}
                aria-pressed={isGrid}
            >
                <GridIcons className="text-[#31398B] size-5" />
            </button>
            <button
                type="button"
                className={`px-3 py-1.5 text-sm rounded-r-md border-l border-gray-200 ${
                    !isGrid
                        ? 'bg-[#E6F0FF] text-[#31398B]'
                        : 'bg-white text-gray-700 hover:bg-gray-50'
                }`}
                onClick={() => onChange('list')}
                aria-pressed={!isGrid}
            >
                <BurgerMenuIcons className="text-[#31398B] size-5" />
            </button>
        </div>
    )
}

export default ViewTypeSwitch
